import { MediaQueryService } from 'src/app/common/services/media.query/media.query.service';
import { VisitorFancyCardComponent } from './../cards/visitor.fancy.card/visitor.fancy.card.component';
import { IAppState } from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { filter, Observable, takeUntil, tap, combineLatestWith, switchMap, of } from 'rxjs';
import { BaseComponent } from 'src/app/common/components/base.component';
import { VisitorEventService } from 'src/app/modules/event-calendar/services/visitor.event.service';
import {
  CalendarActionCommand,
  CalendarQueryCommand,
} from '../../../models/calendar.action.command';
import { VisitorEvent } from '../../../models/visitor.event';
import { frontendSettingsSelector } from '../../../ngrx.stores/frontend.settings/selectors';
import { IFrontendSettings } from '../../../ngrx.stores/frontend.settings/states';
import { routeConfigs } from 'src/app/common/constants/route.config';
import { VisitorPlaceService } from 'src/app/modules/event-calendar/services/visitor.place.service';
import { VisitorPlace } from '../../../models/visitor.place';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { FancyEventDetailsModalComponent } from 'src/app/modules/event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { IEventDetailsModalData } from 'src/app/modules/event-calendar/components/event.details.modal/event.details.modal.provider';
import { FancyPlaceDetailsModalComponent } from 'src/app/modules/place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { IPlaceDetailsModalData } from 'src/app/modules/place-calendar/components/place.details.modal/place.details.modal.provider';

@Component({
  selector: 'ig-one-row-widget',
  templateUrl: './one.row.widget.component.html',
  styleUrls: ['./one.row.widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'ig-one-row-widget',
  },
})
export class OneRowWidgetComponent extends BaseComponent implements OnInit {
  actionCommand: CalendarActionCommand = new CalendarActionCommand();
  data$: Observable<VisitorEvent[] | VisitorPlace[]>;
  frontendSettings$: Observable<IFrontendSettings | null>;
  @ViewChild('container', {static: false}) container: ElementRef;
  @ViewChild('card', {static: false}) card: VisitorFancyCardComponent;

  isAtStart = true;
  isAtEnd = false;

  isDataLoaded = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public eventService: VisitorEventService,
    public placeService: VisitorPlaceService,
    public router: Router,
    public mediaQueryService: MediaQueryService,
    private _modalService: ModalService,
    private _store: Store<IAppState>
  ) {
    super({activatedRoute});

    this.frontendSettings$ = this._store.pipe(
      takeUntil(this.isDestroyed),
      select(frontendSettingsSelector)
    );

    const eventCalendarPath = routeConfigs.visitor.eventCalendar;
    this.actionCommand.isEventCalendar = this.router.url.includes(
      `/${eventCalendarPath.path}`
    );

    this.setWidgetStyleForScriptSolution();
  }

  ngOnInit() {
    this.eventService
      .buildFilterEventsByDateCommandFromUrlQuery(this.activatedRoute)
      .subscribe((command: CalendarQueryCommand) => {
        if (command) {
          this.actionCommand.queryCommand = command;
        }
      });

    this.loadData();
  }

  public getEvents(): Observable<VisitorEvent[]> {
    // this.actionCommand.queryCommand.isForMapView = true;
    this.actionCommand.queryCommand.limit = 999;
    this.actionCommand.queryCommand.page = 1;
    return this.eventService
      .getEvents(this.hubName, this.actionCommand.queryCommand)
      .pipe(
        tap(() => {
          this.checkIsAtStart();
          this.checkIsAtEnd();
        })
      );
  }

  public getPlaces(): Observable<VisitorPlace[]> {
    console.log('getPlaces', this.actionCommand.queryCommand);
    this.actionCommand.queryCommand.limit = 999;
    this.actionCommand.queryCommand.page = 1;
    return this.placeService
      .getPlaces(this.hubName, this.actionCommand.queryCommand)
      .pipe(
        tap(() => {
          this.checkIsAtStart();
          this.checkIsAtEnd();
        })
      );
  }


  public trackByIndex(i: number) {
    return i;
  }

  public get isNeedScroll() {
    if (!this.container) return false;
    return (
      this.container.nativeElement.offsetWidth <
      this.container.nativeElement.scrollWidth
    );
  }

  public checkIsAtStart() {
    if (!this.container) return;
    setTimeout(() => {
      const {scrollLeft} = this.container.nativeElement;
      this.isAtStart = scrollLeft === 0;
    }, 800);
  }

  public checkIsAtEnd() {
    if (!this.container) return;
    setTimeout(() => {
      const {scrollWidth, scrollLeft, clientWidth} =
        this.container.nativeElement;

      this.isAtEnd = scrollWidth - (scrollLeft + clientWidth) <= 10;
    }, 800);
  }

  public goRight() {
    const padding = 16;
    const cardWidth =
      this.card.card.nativeElement.getBoundingClientRect().width + padding;
    const count = this.container.nativeElement.offsetWidth / cardWidth;
    const move = cardWidth * Math.floor(count) || cardWidth;

    this.container.nativeElement.scrollLeft += move;

    this.checkIsAtStart();
    this.checkIsAtEnd();
  }

  public goLeft() {
    const padding = 16;
    const cardWidth =
      this.card.card.nativeElement.getBoundingClientRect().width + padding;
    const count = this.container.nativeElement.offsetWidth / cardWidth;
    const move = cardWidth * Math.floor(count) || cardWidth;

    this.container.nativeElement.scrollLeft -= move;

    this.checkIsAtStart();
    this.checkIsAtEnd();
  }

    // show the event details modal if the url contains eventId
    public showEventDetailsIfHasEventIdInUrl() {
      const searchParams = new URLSearchParams(window.location.search);
      const igEventNameId = searchParams.get('imgoing-event');
      const eventId = igEventNameId ? igEventNameId.split('-').last() : null;
  
      if (eventId) {
        this._modalService.show<FancyEventDetailsModalComponent>({
          component: FancyEventDetailsModalComponent,
          data: {
            eventDetailsId: eventId,
          } as IEventDetailsModalData,
          panelClass: 'ig-modal-w-full',
        });
      }
    }    
    // show the place details modal if the url contains placeId
    public showPlaceDetailsIfHasIdInUrl() {
      const searchParams = new URLSearchParams(window.location.search);
      const igNameId = searchParams.get('imgoing-place');
      const placeId = igNameId ? igNameId.split('-').last() : null;
  
      if (placeId) {
        this._modalService.show<FancyPlaceDetailsModalComponent>({
          component: FancyPlaceDetailsModalComponent,
          data: {
            placeDetailsId: placeId,
          } as IPlaceDetailsModalData,
          panelClass: 'ig-modal-w-full',
        });
      }
    }

  private loadData() {
    if (!this.frontendSettings) {
      setTimeout(() => {
        this.loadData();
      }, 1000);
      return;
    }

    this.activatedRoute.url.subscribe((url) => {

      const path = url[0].path;
      console.log('path in one row', path);

      if (this.actionCommand.isEventCalendar) {
        if (path === routeConfigs.visitor.eventCalendar.editorChoice.path) {
          this.actionCommand.queryCommand.choice = true;
        }

        // show the favorite/custom events
        if (routeConfigs.visitor.eventCalendar.favEvent.path.startsWith(path)) {
          const btnId = this.allRouteParams['customEventBtnId'];
          console.log('btnId', btnId);
          if (btnId) this.actionCommand.queryCommand.favoriteEventBtnId = btnId;
        }

        this.showEventDetailsIfHasEventIdInUrl();
      } else {
        if (path === routeConfigs.visitor.placeCalendar.editorChoice.path) {
          this.actionCommand.queryCommand.choice = true;
        }

        // show the favorite/custom places
        if (routeConfigs.visitor.placeCalendar.favCustomPlace.path.startsWith(path)) {
          const btnId = this.allRouteParams['favCustomPlaceBtnId'];
          console.log('favCustomPlaceBtnId one row:', btnId);
          if (btnId) this.actionCommand.queryCommand.type = btnId;
        }

        // show the custom default place categories
        if (routeConfigs.visitor.placeCalendar.customDefaultPlace.path.startsWith(path)) {
          const btnId = this.allRouteParams['categoryId'];
          let category = this.placeService.findCategoryById(
            btnId,
            this.frontendSettings.customSettings.customDefaultPlaceCategory
              .customCategories
          );
          if (category) {
            let categoryList = [];
            this.placeService.getAllSubCategories(category, categoryList);
            this.actionCommand.queryCommand.categoryList = categoryList;
            this.actionCommand.queryCommand.categoryNode = category;
          }
        }

        this.showPlaceDetailsIfHasIdInUrl();
      }

      this.isDataLoaded = true;
      if (this.actionCommand.isEventCalendar) {
        this.data$ = this.getEvents();
      } else {
        this.data$ = this.getPlaces();
      }
    });

  }

  @HostListener('window:resize')
  private setWidgetStyleForScriptSolution() {
    if (!this.isScriptSolution) return;

    // for mobile, set the widget to be full width, and height to 230px, so that we will show at least 2 cards (the second card will be a little visible)
    this.mediaQueryService.isMobile$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((isMobile) => {
        if (isMobile) {
          const width = window.document.body.clientWidth;
          // this.imgoingWrapper.style.position = 'absolute';
          this.imgoingWrapper.style.left = '0';
          this.imgoingWrapper.style.width = width + 'px';
          // this.imgoingWrapper.style.height = '230px';
          this.imgoingWrapper.style.minHeight = 'unset';
        } else {
          this.imgoingWrapper.style.maxHeight = '100%';
          this.imgoingWrapper.style.minHeight = 'unset';
          this.imgoingWrapper.style.height = '100%';
        }
      });
  }
}
